const SEGMENTED_TABS_SELECTOR = '.ads-segmented-tabs';
const SEGMENTED_TAB_SELECTOR = '.ads-segmented-tab';
const SEGMENTED_TAB_INDICATOR_SELECTOR = '.ads-segmented-tab-indicator';
const INACTIVE_CLASS = 'placement-operation-tab-slider--inactive';
const READY_FLAG = 'segmentedIndicatorReady';
const SEGMENTED_KEY_ATTRIBUTE = 'segmentedTabsKey';

let autoSyncBound = false;
const indicatorPositionCache = new Map();

const getElement = (target) => {
    if (!target) {
        return document;
    }
    if (target instanceof Element || target instanceof Document) {
        return target;
    }
    if (target.jquery) {
        return target[0] || document;
    }
    return document;
};

const resetIndicator = (indicator) => {
    indicator.style.opacity = '0';
    indicator.style.width = '0px';
    indicator.style.transform = 'translateX(0px)';
    delete indicator.dataset[READY_FLAG];
};

const setIndicatorPosition = (indicator, {width, offset, animated}) => {
    if (!animated) {
        indicator.style.transition = 'none';
    } else {
        indicator.style.removeProperty('transition');
    }

    indicator.style.opacity = '1';
    indicator.style.width = `${width}px`;
    indicator.style.transform = `translateX(${offset}px)`;

    if (!animated) {
        indicator.getBoundingClientRect();
    }
};

const restoreIndicatorTransition = (indicator) => {
    requestAnimationFrame(() => {
        indicator.style.removeProperty('transition');
    });
};

const applyIndicatorPosition = (tabs, indicator, width, offset) => {
    const key = tabs.dataset[SEGMENTED_KEY_ATTRIBUTE] || '';
    const previous = key ? indicatorPositionCache.get(key) : null;
    const wasReady = indicator.dataset[READY_FLAG] === 'true';

    if (!wasReady && previous) {
        setIndicatorPosition(indicator, {...previous, animated: false});
        indicator.dataset[READY_FLAG] = 'true';
        requestAnimationFrame(() => {
            indicator.style.removeProperty('transition');
            indicator.getBoundingClientRect();
            requestAnimationFrame(() => {
                setIndicatorPosition(indicator, {width, offset, animated: true});
                if (key) {
                    indicatorPositionCache.set(key, {width, offset});
                }
            });
        });
        return;
    }

    setIndicatorPosition(indicator, {width, offset, animated: wasReady});
    indicator.dataset[READY_FLAG] = 'true';
    if (key) {
        indicatorPositionCache.set(key, {width, offset});
    }

    if (!wasReady) {
        restoreIndicatorTransition(indicator);
    }
};

export const syncSegmentedTabIndicator = (container) => {
    const tabs = getElement(container);
    if (!(tabs instanceof Element)) {
        return;
    }

    const indicator = tabs.querySelector(SEGMENTED_TAB_INDICATOR_SELECTOR);
    const activeTab = tabs.querySelector(`${SEGMENTED_TAB_SELECTOR}.active`);

    if (!indicator || !activeTab || tabs.classList.contains(INACTIVE_CLASS)) {
        if (indicator) {
            resetIndicator(indicator);
        }
        return;
    }

    const tabsRect = tabs.getBoundingClientRect();
    const activeRect = activeTab.getBoundingClientRect();
    if (tabsRect.width <= 0 || activeRect.width <= 0) {
        resetIndicator(indicator);
        return;
    }

    applyIndicatorPosition(tabs, indicator, activeRect.width, activeRect.left - tabsRect.left);
};

export const syncSegmentedTabs = (root = document) => {
    const element = getElement(root);
    if (element instanceof Element && element.matches(SEGMENTED_TABS_SELECTOR)) {
        syncSegmentedTabIndicator(element);
    }
    element.querySelectorAll(SEGMENTED_TABS_SELECTOR).forEach(syncSegmentedTabIndicator);
};

export const bindSegmentedTabsAutoSync = () => {
    if (autoSyncBound || typeof window === 'undefined') {
        return;
    }
    autoSyncBound = true;
    window.addEventListener('resize', () => syncSegmentedTabs(document));
    document.addEventListener('shown.bs.modal', (event) => syncSegmentedTabs(event.target));
    if (document.fonts?.ready) {
        document.fonts.ready.then(() => syncSegmentedTabs(document)).catch(() => {});
    }
};
